<ceg-budget-allocations-table
  [objectId]="objectId"
  [objectType]="objectType"
  [campaignIsClosed]="campaignIsClosed"
  [isReadOnlyMode]="isReadOnlyMode"
  [isSegmentlessCampaign]="isSegmentlessCampaign"
  [externalIntegrationType]="externalIntegrationType"
  [tableColumns]="tableColumns"
  [tableRows]="tableRows"
  [allocationTotals]="allocationTotals"
  (onAllocationChange)="onChange.emit($event)"
  (onForecastAmountChange)="onForecastChange.emit($event)"
  (openExpenses)="openExpensePage($event?.timeframeId)"
  (openBudgetAllocationDetails)="openManageCEGPage($event?.timeframeId)"
  [companyId]="companyId"
  [budget]="budget"
  [isForecastEnabled]="isForecastEnabled"
></ceg-budget-allocations-table>
